import React from "react";
import { AdaptiveSearchBarProps } from "@/components/pages/home/components/searchbar/searchbar";
import styles from "@/components/pages/home/components/searchbar/styles/searchbar.module.scss";
import GenderSelector from "@/components/pages/home/components/searchbar/components/gender-selector";
import SearchBarContainer from "@/components/pages/home/components/searchbar/components/searchbar-container";
import FiltersCardsContainer from "@/components/pages/home/components/searchbar/components/filters-cards-container";
import Dropdown, {
  DropdownSelectorOption,
} from "@/components/pages/home/components/searchbar/components/dropdown";
import { useCategoriesDropdownContext } from "@/components/pages/home/providers/categories-dropdown-provider";
import $filters from "@/data/filters.constants";

const DesktopSearchbar = ({
  onSelectGender,
  onSearch,
  filters,
  handleFilterClick,
  selectedFilter,
  scrollY,
}: AdaptiveSearchBarProps) => {
  const { value, setValue } = useCategoriesDropdownContext();

  const handleDropdownSelect = (option?: DropdownSelectorOption) => {
    handleFilterClick(option ?? $filters.defaultModelFilter);
    setValue(option);
  };

  return (
    <div className={styles.searchbar}>
      <FiltersCardsContainer
        selectedFilter={selectedFilter}
        onSelectFilter={(filter) => {
          handleFilterClick(filter);
          setValue(filter);
        }}
        scrollY={scrollY}
      />
      <div className={styles.searchbar_filters}>
        <div className={styles.searchbar_menus}>
          <GenderSelector onSelectGender={onSelectGender} />
          <Dropdown
            selectedOption={value}
            onSelect={handleDropdownSelect}
            items={filters}
            placeholder={"Categories"}
          />
        </div>
        <SearchBarContainer onSearch={onSearch} />
      </div>
    </div>
  );
};

export default DesktopSearchbar;
